import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  getPets,
  addPet,
  showAddPetModal,
  removePet,
  editPet
} from "../../store/pet/actions";
import { connect } from "react-redux";
import PetList from "./List/PetList";
import AddPet from "./AddPet";
import {userRols} from "../../helpers/userRols";
import Paging from "components/Pagination/Pagination";
import ListSearch from "components/ListSearch/ListSearch";

class Pets extends Component {
  constructor(props) {
    super(props);

    this.onNewPetModal = this.onNewPetModal.bind(this);
    this.onNewPetSubmit = this.onNewPetSubmit.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.props.getPets({role: userRols.parent});
  }

  setPage = (currentPage) => {
    this.props.getPets({ role: userRols.parent, page: currentPage });
  }

  setPageSize = (pageSize) => {
    this.props.getPets({ role: userRols.parent, pageSize, page: 1 });
  }

  handleSearch = (q) => {
    this.props.getPets({ role: userRols.parent, q, page: 1 });
  }

  onNewPetModal() {
    this.props.showAddPetModal(!this.props.isAddNewPetOpen);
  }

  onNewPetSubmit(pet) {
    this.props.addPet(pet);
  }

  onRemove(pet) {
    this.props.removePet(pet);
  }

  onEdit(pet) {
    this.props.editPet(pet);
  }

  render() {
    const { petList, isLoadingAddPet, isAddNewPetOpen, query } = this.props;
    const { page: currentPage, pageSize, q } = query;
    const total = petList?.total || 0;
    const pages = petList?.pages || 1;
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Домашни любимци" breadcrumbItem="Домашни любимци" />

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <div className="list-toolbar mb-3">
                      <Paging
                        setPage={this.setPage}
                        setPageSize={this.setPageSize}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        pages={pages}
                      />
                      <ListSearch
                        value={q || ""}
                        onSearch={this.handleSearch}
                        placeholder="Търсене по стопанин, любимец или порода"
                      />
                    </div>

                    <div className="mb-2 text-muted">
                      Общо: {total} домашни любимци
                    </div>

                    <PetList
                      list={petList}
                      onRemoveItem={this.onRemove}
                      history={this.props.history}
                    />
                  </CardBody>
                  <Paging
                    setPage={this.setPage}
                    setPageSize={this.setPageSize}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    pages={pages}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <AddPet
          isLoading={isLoadingAddPet}
          isNewPetModalOpen={isAddNewPetOpen}
          onSubmit={this.onNewPetSubmit}
          onCancel={this.onNewPetModal}
        />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { Pet } = state;
  return Pet;
};

export default connect(mapStatetoProps, {
    getPets,
    addPet,
    showAddPetModal,
    removePet,
    editPet
  })(Pets);
